//*react- recursos
import React, { useEffect, useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
//import {toast} from "react-toastify";

//*componentes-utiles
import DivLoading from "../DivLoading";
import Swal from "sweetalert2";

//*clases
import { Col, Row } from "react-bootstrap";
import { Label } from "@reactjscomponentrepository/frontend-components/lib/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

//*datos

//*archivos (imagenes y elementos necesarios para la rutina)

//*api's (servicios y store)

//*store's
import filesStore from "../../stores/filesStore";

//*interfaces
interface PropsDrop {
  posi: any;
  archDrop?: any;
}

//*componente
export default function GeneraDropzoneUnArchivo(props: PropsDrop) {
  //*store
  const { setGuardaFiles, setEliminaFiles } = filesStore((state: any) => ({
    setGuardaFiles: state.setGuardaFiles,
    setEliminaFiles: state.setEliminaFiles,
  }));

  //*data //mis etiquetas
  const myLabels = [
    { id: 0, desc: "Cargar archivos" },
    { id: 1, desc: "Remover todos los archivos" },
    { id: 2, desc: "Borrar archivo" },
    { id: 3, desc: "Resultado de la validación:" },
    { id: 4, desc: "¿Desea remover <strong>TODOS</strong> los archivos?" },
    { id: 5, desc: "¿Desea remover el archivo seleccionado?" },
    {
      id: 6,
      desc: "Todos los archivos son válidos para realizar la actualización del tema.",
    },
    {
      id: 7,
      desc: 'Para continuar de clic en el botón  <strong>"Procesar archivos"</strong>',
    },
    {
      id: 8,
      desc: " archivo(s) <strong>no</strong> es (son) válido(s) para realizar la actualización del tema. ",
    },
    {
      id: 9,
      desc: "El sistema lo(s) eliminará del espacio para cargar los archivos.",
    },
    { id: 10, desc: "¿Desea continuar con los archivos válidos?" },
    { id: 11, desc: "Examinar" },
  ];

  //*variables
  //let filesIn = [] as any;
  //let datf= [] as any;
  //const [filesTotal, setFilesTotal] = useState(0);
  const [myFiles, setMyFiles] = useState([] as any);
  //const [filesInvalid, setFilesInvalid] = useState([] as any);
  //const [show, setShow] = useState(false);
  //const [perSel,setPerSel]= useState(period);
  const [openDivLoading, setOpenDivLoading] = useState(false);

  //*funciones
  //--Componente Dropzone
  function MyDropzone() {
    const onDrop = useCallback(
      (acceptedFiles) => {
        //let listaFilesDupli="";
        //let acceptedFilesTemp:any=[];
        //let filesCarg=0;

        setMyFiles([...acceptedFiles]);
        setGuardaFiles(props.posi, acceptedFiles);
        //funciones del api store (stepStore.tsx)
      },
      [myFiles]
    );

    //--constantes de funcionalidades del dropzone, abre la ventana etc.
    //multiple falso es para que cargue solo 1, si quitamos la propiedad permite generar múltiples archivos
    const { getRootProps, getInputProps } = useDropzone({
      multiple: false,
      onDrop,
    });

    //removeFile remueve los archivos de nuestra lista (remueve de uno a uno)
    const removeFile = (file: any) => () => {
      Swal.fire({
        //title: myLabels[11].desc,
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        width: "40%",
        html: "<div>" + myLabels[5].desc + "</div>",
      }).then((result) => {
        if (result.isConfirmed) {
          const newFiles = [...myFiles];
          newFiles.splice(newFiles.indexOf(file), 1);
          setMyFiles(newFiles);
          setEliminaFiles(props.posi);
          // console.log("newFiles *******",newFiles.length);
          if (newFiles.length == 0) {
            //no tiene archivos
            console.log("No tengo archivos");
          } else console.log("Si tengo archivos");
          //funciones del store (stepStore.tsx)
        }
      });
    };

    //-- genera el listado donde se acumulan nuestros archivos (lo que se pinta en el dropzone)
    const files = myFiles.map((file: any) => (
      <li key={file.name}>
        <Row>
          <Col sm={7} className="small align-1">
            {file.name}
          </Col>
          <Col sm={5}>
            <button
              title={myLabels[2].desc}
              onClick={removeFile(file)}
              className="btn rounded-pill "
            >
              <FontAwesomeIcon icon={faTrashAlt} className="color-blue-2" />
            </button>
          </Col>
        </Row>
      </li>
    ));

    //--pintado del dropzone (adecuado a nuestro diseño)
    return (
      <Row className="display-flex">
        <Col sm={2} className="">
          <section className="sectionDrop botonExaminar ">
            <div {...getRootProps({ className: "" })}>
              <input className="inputExaminar" {...getInputProps()} />
              <Label className="etiquetaExaminar">{myLabels[11].desc}</Label>
            </div>
          </section>
        </Col>
        <Col sm={10} className="inputExaminar">
          <aside>
            {/* nuestro listado que vamos acumulando*/}
            <ul>{files}</ul>
          </aside>
        </Col>
      </Row>
    );
  }

  //const handleClose = (filesV:any) => setShow(false);

  //*vista
  return (
    <>
      <div className="backcolor-white">
        {/* <Row className="padding-3 padding-11 padding-14"> se quitaron los padding porque tenia mucho espacio*/}
        <Row className="">
          <Col sm={12} className="divDropzoneUnArchivo">
            <MyDropzone />
          </Col>
        </Row>
      </div>

      {openDivLoading ? <DivLoading /> : null}
    </>
  );
}
